import { Box, CardContent, Grid2, Typography } from '@mui/material';
import BasicLayout from 'pages/AuthenticationPages/_components/BasicLayout';
import { LoginFormSchema } from '../../../services/AuthService/schemas';
import zod from 'zod';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import Card from '@mui/material/Card';
import TextFieldComponent from '../../../components/TextFieldComponent';
import { LoadingButton } from '@mui/lab';
import testeSvg from 'assets/images/svgs/SignInSVGS/5.svg';
import React from 'react';
import logo_login from 'assets/images/logoProdutos/alertai_icon_blue_dark.svg';

type LoginFormInput = zod.infer<typeof LoginFormSchema>;

const NewPassword = () => {
  const { control, handleSubmit } = useForm<LoginFormInput>({
    resolver: zodResolver(LoginFormSchema),
    defaultValues: { email: '', password: '' },
  });

  return (
    <BasicLayout>
      <Card
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-around',
          position: 'absolute',
          backgroundColor: 'transparent',
        }}
      >
        <Grid2
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          sx={{ height: '100%' }}
        >
          <img src={testeSvg} alt="Desenho" width={500} />
        </Grid2>
        <CardContent
          sx={{
            backgroundColor: 'transparent',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box pt={4} pb={6} px={3} sx={{ width: '100%' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '14vh',
              }}
            >
              <img src={logo_login} width={260} />
            </Box>

            <Box sx={{ width: '100%' }}>
              <Typography color="white" variant="h4" marginY={'20px'}>
                Redefinir senha
              </Typography>

              <Box mb={1}>
                <Controller
                  control={control}
                  name={'password'}
                  render={({ field: { value, onChange } }) => (
                    <TextFieldComponent
                      type="password"
                      label="Nova senha"
                      fullWidth
                      value={value}
                      onChangeText={onChange}
                    />
                  )}
                />
              </Box>
            </Box>
            <Box sx={{ width: '100%' }}>
              <Box mb={1}>
                <Controller
                  control={control}
                  name={'password'}
                  render={({ field: { value, onChange } }) => (
                    <TextFieldComponent
                      type="password"
                      label="Confirmar senha"
                      fullWidth
                      value={value}
                      onChangeText={onChange}
                    />
                  )}
                />
              </Box>
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                mt={-1}
                mb={1}
              >
                <LoadingButton
                  type="submit"
                  variant="contained"
                  color="primary"
                  loadingPosition="center"
                  sx={{
                    width: '40%',
                    margin: '10px',
                  }}
                >
                  Redefinir
                </LoadingButton>

                <LoadingButton
                  type="submit"
                  color="primary"
                  variant="outlined"
                  loadingPosition="center"
                  href="/app/authentication/tokenPassword"
                  sx={{
                    width: '40%',
                  }}
                >
                  Voltar
                </LoadingButton>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </BasicLayout>
  );
};

export default NewPassword;
